module.exports = __webpack_public_path__ + "static/011.thumb-3638935f55d4510b88f156cc62129e80.jpg";